import React, { useState } from 'react';
import cn from 'classnames';
import { useController, Control, FieldValues } from 'react-hook-form';
import './index.scss';
import { formatDateToTimeZone } from 'utils/functions';

interface InputProps {
	label?: string;
	labelClass?: 'sm' | 'md';
	placeholder?: string;
	className?: string;
	type?: string;
	disabled?: boolean;
	inputClasses?: string;
	textareaHeight?: number;
	control?: Control<FieldValues | any>;
	defaultValue?: any;
	name: string;
	rows?: number;
}

export const InputControlled = ({
	label,
	labelClass,
	inputClasses,
	type,
	control,
	name,
	disabled = false,
	defaultValue,
	className,
	rows = 4,
}: InputProps) => {
	const { field, fieldState } = useController({ control, name, defaultValue });
	const [value, setValue] = useState(
		defaultValue
			? type === 'date'
				? formatDateToTimeZone(new Date(defaultValue))
				: defaultValue
			: undefined
	);

	return (
		<div className={cn('input-container', className)}>
			{label && (
				<label
					htmlFor={field.name}
					className={`label ${labelClass}`}
				>
					{label}
				</label>
			)}
			{type === 'textarea' ? (
				<textarea
					disabled={disabled}
					className={cn(
						{
							'outline outline-2 outline-red': fieldState.error,
						},
						inputClasses
					)}
					rows={rows}
					{...field}
					value={value}
					onChange={({ target }) => {
						setValue(target.value);
						field.onChange(target.value);
					}}
				/>
			) : (
				<input
					disabled={disabled}
					type={type}
					className={cn(
						{
							'outline outline-2 outline-red': fieldState.error,
						},
						inputClasses
					)}
					{...field}
					value={value}
					onChange={({ target }) => {
						setValue(target.value);
						field.onChange(target.value);
					}}
				/>
			)}
			{fieldState.error && (
				<div className='mt-2 text-red text-xs normal-case capitalize'>
					{fieldState.error.message}
				</div>
			)}
		</div>
	);
};
